import React, {useState} from "../../../../__snowpack__/pkg/react.js";
import {InputNumber} from "../../../../__snowpack__/pkg/antd.js";
import {useDebounceFn, useUpdateEffect} from "../../../../__snowpack__/pkg/ahooks.js";
const DebounceInputNumber = React.forwardRef((props, inputRef) => {
  const {delay = 500, value, onChange = () => {
  }, onBlur, ...restProps} = props;
  const [inputValue, setInputValue] = useState(value);
  const {run, flush} = useDebounceFn(onChange, {wait: delay});
  useUpdateEffect(() => {
    if (value !== inputValue) {
      setInputValue(value);
    }
  }, [value]);
  return React.createElement(InputNumber, {
    ref: inputRef,
    ...restProps,
    value: inputValue,
    onChange: (_value) => {
      setInputValue(_value);
      run?.(_value);
    },
    onBlur: (e) => {
      flush();
      onBlur?.(e);
    }
  });
});
DebounceInputNumber.displayName = "DebounceInputNumber";
export default DebounceInputNumber;
